import { render, staticRenderFns } from "./businessProfile.vue?vue&type=template&id=625f1cc0&"
import script from "./businessProfile.vue?vue&type=script&lang=js&"
export * from "./businessProfile.vue?vue&type=script&lang=js&"
import style0 from "./businessProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports